<template>
  <v-container grid-list-md fluid pa-0>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card class="px-2">
          <v-card-title>
            <span class="title">{{formTitle}}</span>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-form v-model="valid" ref="form">
              <v-container grid-list-md fluid>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedProcedure.name"
                      :rules="[required]"
                      label="Name"
                      required
                      name="name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedProcedure.fee"
                      :rules="[required]"
                      label="Fee"
                      required
                      type="number"
                      name="fee"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      v-model="editedProcedure.description"
                      label="Description"
                      name="description"
                      rows="3"
                    ></v-textarea>
                  </v-flex>

                  <v-flex xs12 class="text-xs-right">
                    <v-spacer></v-spacer>
                    <v-btn flat @click="close">Cancel</v-btn>
                    <v-btn
                      class="mx-0"
                      :disabled="!valid"
                      :loading="saving"
                      color="primary"
                      @click="save"
                    >Save</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout
      row
      wrap
      align-center
      justify-end
      :class="{'rt-5': $vuetify.breakpoint.name !== 'xs'}"
      
    >
      <v-flex xs12 sm6 md4 mx-2 class="pointer-event-auto">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          label="Search"
          v-model="search"
          hide-details
          single-line
          outline
          class="rounded"
        >
          <v-tooltip top slot="append-outer">
            <v-icon
              class="mx-2"
              medium
              slot="activator"
              @click="dialog = true"
              color="secondary"
            >mdi-plus-circle</v-icon>

            <span>New Procedure</span>
          </v-tooltip>
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
          :search="search"
          :headers="headers"
          :items="procedures"
          disable-initial-sort
          :rows-per-page-items="per_page"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>{{props.item.id}}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.fee }}</td>
              <td>{{ props.item.description }}</td>

              <td>
                <v-tooltip top>
                  <v-icon
                    slot="activator"
                    class="mx-1"
                    @click="confirmDelete(props.item)"
                  >mdi-delete-outline</v-icon>
                  <span>Delete</span>
                </v-tooltip>

                <v-tooltip top>
                  <v-icon
                    slot="activator"
                    class="mx-1"
                    @click="editProcedure(props.item)"
                  >mdi-pencil-outline</v-icon>
                  <span>Edit</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  middleware: "admin",
  data() {
    return {
      procedure: {},
      required: v => !!v || "This field is required.",
      valid: true,
      defaultProcedure: {
        name: "",
        fee: "",
        description: ""
      },
      editedProcedure: {
        name: "",
        fee: "",
        description: ""
      },
      search: "",
      editedIndex: -1,
      dialog: false,
      saving: false,
      headers: [
        { text: "#", value: "id" },
        { text: "Procedure Name", value: "name" },
        { text: "Fee", value: "fee" },
        { text: "Description", value: "description" },
        { text: "", value: "name", sortable: false, width: 200 }
      ]
    };
  },
  computed: {
    procedures() {
      return this.$store.getters["base/procedures"];
    },
    formTitle() {
      return this.editedIndex === -1 ? "Add New Procedure" : "Edit Procedure";
    }
  },

  methods: {
    close() {
      this.saving = false;
      this.dialog = false;
      this.$refs.form.reset();
      Object.assign(this.editedProcedure, this.defaultProcedure);
      this.editedIndex = -1;
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        if (this.editedIndex > -1) {
          await this.axios.put(
            `api/procedures/${this.editedProcedure.id}`,
            this.editedProcedure
          );
        } else {
          await this.axios.post("api/procedures", this.editedProcedure);
        }

        this.$store.dispatch("base/loadProcedures", true);
        this.close();
      }
    },

    editProcedure(procedure) {
      this.editedIndex = procedure.id;
      Object.assign(this.editedProcedure, procedure);
      this.dialog = true;
    },

    confirmDelete(procedure) {
      const params = {
        title: `Delete "${procedure.name}"`,
        message: `Are you sure, you want to delete the procedure "${
          procedure.name
        }"?`,
        // typeText: true,
        mode: "delete",
        onConfirm: () => this.deleteProcedure(procedure)
      };

      this.$modal.show(params);
    },

    deleteProcedure(procedure) {
      this.axios
        .delete(`api/procedures/${procedure.id}`)
        .then(result => {
          this.$store.dispatch("base/loadProcedures", true);
        })
        .catch(err => {
          this.$snackbar.error("Could not delete this procedure.");
        });
    }
  },
  mounted() {
    this.$store.dispatch("base/loadProcedures");
  }
};
</script>

<style scoped>
</style>